import { useBulkProjectOrClientBillingDefaultsForAvailableToBill } from '~/modules/billing-invoicing/common/components/AvailableToBillListTable/hooks/useBulkProjectOrClientBillingDefaultsForAvailableToBill';
import { mapRepliconDateToMidnightUTCString } from '~/modules/common/dates/convert';
import {
  useClientDefaultData,
  useInvoiceDefaultTemplate,
  useProjectDefaultBillingData
} from '~/modules/billing-invoicing/common/hooks';
import { useHasFeatureFlag } from '~/modules/common/hooks';

export const useBillingDefaults = ({
  availableToBillProject,
  client,
  projectUri,
  startDate,
  endDate
}) => {
  const isPsaPrpAddProjectColumnOnAvailableToBillEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPrpAddProjectColumnOnAvailableToBillEnabled'
  });
  const { invoiceDefaultTemplate } = useInvoiceDefaultTemplate();

  const { clientDefaultData } = useClientDefaultData({ client });

  const projectsBillingSettingsById = useProjectDefaultBillingData({
    projectIds: [availableToBillProject?.id].filter(Boolean),
    skip: !isPsaPrpAddProjectColumnOnAvailableToBillEnabled
  });

  const {
    projectOrClientBillingDefaults
  } = useBulkProjectOrClientBillingDefaultsForAvailableToBill(
    [
      {
        clientUris: [client.id],
        projectUris: projectUri ? [projectUri] : undefined,
        billingPeriod:
          startDate && endDate
            ? {
                startDate: mapRepliconDateToMidnightUTCString(startDate),
                endDate: mapRepliconDateToMidnightUTCString(endDate)
              }
            : undefined
      }
    ],
    isPsaPrpAddProjectColumnOnAvailableToBillEnabled
  );

  const billingDefaults =
    (projectOrClientBillingDefaults && projectOrClientBillingDefaults[0]) || {};

  if (isPsaPrpAddProjectColumnOnAvailableToBillEnabled) {
    return {
      billingDefaults: {
        ...(clientDefaultData || {}),
        ...(clientDefaultData?.billingSettings || {}),
        ...(projectsBillingSettingsById[availableToBillProject?.id] || {})
      },
      invoiceDefaultTemplate,
      clientDefaultData
    };
  }

  return {
    billingDefaults,
    invoiceDefaultTemplate,
    clientDefaultData
  };
};
